import * as Yup from 'yup';

export default Yup.object().shape({
  merchant: Yup.object()
    .required('This field is required!')
    .typeError('This field is required!')
});
